import React, { useState } from 'react';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';
import ApiDataService from '../../services/ApiDataService';

const UploadDialog = ({ show, currentPath, onClose, onUploaded }) => {
  const [files, setFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [results, setResults] = useState(null);

  const handleUpload = () => {
    if (files.length === 0) return;
    setUploading(true);
    setResults(null);
    const formData = new FormData();
    formData.append('path', currentPath);
    files.forEach(file => formData.append('files[]', file));

    ApiDataService.post('admin/portal/file-manager/upload', formData).then(response => {
      setUploading(false);
      if (response.data.return_status === "0") {
        setResults(response.data.result.results || []);
        onUploaded();
      } else {
        setResults([{ name: '', status: 'error', error: response.data.error_message }]);
      }
    }).catch(error => {
      setUploading(false);
      setResults([{ name: '', status: 'error', error: error.message }]);
    });
  };

  const handleClose = () => {
    setFiles([]);
    setResults(null);
    onClose();
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Upload to {currentPath || 'uploads'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Control
          type="file"
          multiple
          accept=".jpg,.jpeg,.png,.webp"
          onChange={(e) => setFiles(Array.from(e.target.files))}
        />
        {results && (
          <ul className="mt-3">
            {results.map((r, i) => (
              <li key={i} style={{ color: r.status === 'done' ? 'green' : 'red' }}>
                {r.name}: {r.status === 'done' ? 'uploaded' : r.error}
              </li>
            ))}
          </ul>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>Close</Button>
        <Button onClick={handleUpload} disabled={uploading || files.length === 0}>
          {uploading ? <Spinner animation="border" size="sm" /> : 'Upload'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UploadDialog;
